import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    current_password: Yup.string()
      .required("Please enter current password")
      .min(8, "Password must be of at least 8 characters in length")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter"),
    new_password: Yup.string()
      .required("Please enter new password")
      .min(8, "New password must be of at least 8 characters in length")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter"),
    confirm_new_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Please enter confirm password")
  }),
  mapPropsToValues: props => ({
    current_password: "",
    new_password: "",
    confirm_new_password: ""
  }),
  handleSubmit: values => {},
  validateOnMount: true,
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
